import { API_URL } from "helpers/constant";
import { request } from "./api";

export function getListCategories(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}/product/categories${
    queryString ? `?${queryString}` : ""
  }`;

  return request({
    url,
    method: "GET",
  });
}

export function createCategory(body) {
  return request({
    url: `${API_URL}/product/categories`,
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateCategory(body) {
  return request({
    url: `${API_URL}/product/categories`,
    method: "PUT",
    body: JSON.stringify(body),
  });
}
